import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login';
import Home from '@/views/Home';
import NotFound from '@/views/NotFound'
import index from '@/views/index'
import system_menu from '@/views/system/menu'; //菜单管理
import system_admin from '@/views/system/admin'; //用户管理
import system_sale_index from '@/views/system/sale_index'; //销售管理
import system_sale_record from '@/views/system/sale_record'; //销售记录
import system_role from '@/views/system/role'; //角色管理
import system_data_dictionary from '@/views/system/data_dictionary'; //角色管理
import system_data_dictionary_list from '@/views/system/data_dictionary_list'; //角色管理

import teacher_index from '@/views/teacher/index'; //老师管理
import teacher_apply from '@/views/teacher/apply'; //老师申请
import teacher_activity from '@/views/teacher/activity'; //活动
import teacher_activity_list from '@/views/teacher/activity_list'; //活动
import teacher_learning_center from '@/views/teacher/learning_center'; //老师管理
import teacher_course_index from '@/views/teacher/course_index'; //课程管理
import teacher_inventory from '@/views/teacher/inventory'; //课程库存管理
import teacher_course_camp from '@/views/teacher/course_camp'; //课程夏列营
import teacher_course_sort from '@/views/teacher/course_sort'; //课程分类管理
import teacher_course_private from '@/views/teacher/course_private'; //私教课
import private_index from '@/views/private/index'; //私教课
// import teacher_course_sort_list from '@/views/teacher/course_sort_list'; //课程分类二级管理
import teacher_course_arrange from '@/views/teacher/course_arrange'; //课程安排
// import teacher_student_list from '@/views/teacher/student_list'; //学生列表
// import teacher_camp_list from '@/views/teacher/camp_list'; //学生列表

import news_index from '@/views/news/index'; //文章管理
import search_index from '@/views/search/index'; //首页筛选
import adv_index from '@/views/adv/index'; //广告管理
import parent_index from '@/views/parent/index'; //家长管理
import tidings_index from '@/views/tidings/index'; //消息列表
import order_index from '@/views/order/index'; //订单列表
import order_sellerList from '@/views/order/sellerList'; //销售统计列表
import order_info from '@/views/order/info'; //订单详情
import mail_index from '@/views/mail/index'; //邮件
import mail_content from '@/views/mail/content'; //内容模板
import journal_index from '@/views/journal/index'; //日志 添加学生
import journal_record from '@/views/journal/record'; //日志 退款
import journal_score from '@/views/journal/score'; //日志 积分
import feedback_index from '@/views/feedback/index'; //留言列表
import virtual_index from '@/views/virtual/index'; //虚拟班级
import virtual_course from '@/views/virtual/course'; //常规课虚拟班级
import virtual_camp from '@/views/virtual/camp'; //夏令营虚拟班级
import certificate_index from '@/views/certificate/index'; //证书模板
import statistic_index from '@/views/statistic/index'; //评估表统计
import statistic_course from '@/views/statistic/course'; //评估表统计
import statistic_camp from '@/views/statistic/camp'; //评估表统计
import notice_index from '@/views/notice/index'; //评估表统计
import coupon_index from '@/views/coupon/index'; //优惠券
import sharing_index from '@/views/sharing/index'; //优惠券

Vue.use(Router)
var routes=[
	{
		path: '/login',
		name: 'login',
		url: 'login',
		show:false,
		icon_url: 'el-icon-eleme',
		component: login
	},
	{
		path: '/NotFound',
		name: 'NotFound',
		url: 'NotFound',
		show:false,
		icon_url: 'el-icon-eleme',
		component: NotFound
	},
	{
		path: '/',
		name: '',
		component: Home,
		children: [
			{
				path: 'index',
				component: index,
				name: '首页'
			},
			{
				path: 'system_menu',
				component: system_menu,
				name: '目录管理'
			},
			{
				path: 'system_admin',
				component: system_admin,
				name: '用户管理'
			},
			{
				path: 'system_role',
				component: system_role,
				name: '角色管理'
			},
			{
				path: 'system_data_dictionary',
				component: system_data_dictionary,
				name: '数据字典'
			},
			{
				path: 'system_data_dictionary_list',
				component: system_data_dictionary_list,
				name: '数据字典列表'
			},
			{
				path: 'system_sale_index',
				component: system_sale_index,
				name: '销售管理'
			},
			{
				path: 'system_sale_record',
				component: system_sale_record,
				name: '销售记录'
			},
			{
				path: 'tidings_index',
				component: tidings_index,
				name: '消息管理'
			},
			{
				path: 'mail_index',
				component: mail_index,
				name: '邮件模板'
			},
			{
				path: 'mail_content',
				component: mail_content,
				name: '内容模板'
			},
			{
				path: 'feedback_index',
				component: feedback_index,
				name: '留言列表'
			},
			{
				path: 'coupon_index',
				component: coupon_index,
				name: '优惠券'
			},
			
		],
	},





	{
		path: '/',
		name: '',
		component: Home,
		children: [
			{
				path: 'teacher_learning_center',
				component: teacher_learning_center,
				name: '学习中心'
			},
			{
				path: 'teacher_index',
				component: teacher_index,
				name: '老师管理'
			},
			{
				path: 'teacher_apply',
				component: teacher_apply,
				name: '老师申请'
			},
			{
				path: 'teacher_course_index',
				component: teacher_course_index,
				name: '课程管理'
			},
			{
				path: 'teacher_inventory',
				component: teacher_inventory,
				name: '课程库存管理'
			},
			{
				path: 'teacher_course_camp',
				component: teacher_course_camp,
				name: '课程夏列营'
			},
			{
				path: 'teacher_course_sort',
				component: teacher_course_sort,
				name: '课程分类管理'
			},
			{
				path: 'teacher_course_private',
				component: teacher_course_private,
				name: '私教课'
			},
			{
				path: 'teacher_activity',
				component: teacher_activity,
				name: '活动'
			},
			{
				path: 'teacher_activity_list',
				component: teacher_activity_list,
				name: '活动详情'
			},
			{
				path: 'private_index',
				component: private_index,
				name: '私教课的全部和虚拟班级'
			},
			// {
			// 	path: 'teacher_course_sort_list',
			// 	component: teacher_course_sort_list,
			// 	name: '课程分类管理二级'
			// },
			{
				path: 'teacher_course_arrange',
				component: teacher_course_arrange,
				name: '课程安排'
			},
			// {
			// 	path: 'teacher_student_list',
			// 	component: teacher_student_list,
			// 	name: '学生列表'
			// },
			// {
			// 	path: 'teacher_camp_list',
			// 	component: teacher_camp_list,
			// 	name: '学生列表(夏令营)'
			// },
			{
				path: 'news_index',
				component: news_index,
				name: '文章管理'
			},
			{
				path: 'search_index',
				component: search_index,
				name: '首页筛选'
			},
			{
				path: 'adv_index',
				component: adv_index,
				name: '广告管理'
			},
			{
				path: 'parent_index',
				component: parent_index,
				name: '家长管理'
			},
			{
				path: 'order_index',
				component: order_index,
				name: '订单管理'
			},
			{
				path: 'order_sellerList',
				component: order_sellerList,
				name: '销售统计'
			},
			{
				path: 'order_info',
				component: order_info,
				name: '订单详情'
			},
			{
				path: 'journal_index',
				component: journal_index,
				name: '日志'
			},
			{
				path: 'journal_record',
				component: journal_record,
				name: '退款记录日志'
			},
			{
				path: 'journal_score',
				component: journal_score,
				name: '积分日志'
			},
			{
				path: 'virtual_index',
				component: virtual_index,
				name: '虚拟班级'
			},
			{
				path: 'virtual_course',
				component: virtual_course,
				name: '常规课虚拟班级'
			},
			{
				path: 'virtual_camp',
				component: virtual_camp,
				name: '夏令营虚拟班级'
			},
			{
				path: 'certificate_index',
				component: certificate_index,
				name: '证书模板'
			},
			{
				path: 'statistic_index',
				component: statistic_index,
				name: '评估表统计'
			},
			{
				path: 'statistic_course',
				component: statistic_course,
				name: '常规课统计'
			},
			{
				path: 'statistic_camp',
				component: statistic_camp,
				name: '夏令营统计'
			},
			{
				path: 'notice_index',
				component: notice_index,
				name: '通知'
			},
			{
				path: 'sharing_index',
				component: sharing_index,
				name: '分账管理'
			},
		]
	},
];
Vue.prototype.routes_data = routes;
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js